import React from 'react';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { LEAD_SOURCE_CONFIG, DEFAULT_LEAD_SOURCE } from './leadSourceConfig';

const LeadSourceChip = ({ source }) => {
  // Use the config for the source if it exists, otherwise use the default config
  const config = LEAD_SOURCE_CONFIG[source] || LEAD_SOURCE_CONFIG[DEFAULT_LEAD_SOURCE];
  
  // Get the display label based on the source
  const displayLabel = config.label;
  
  return (
    <Tooltip title={displayLabel} placement="top" arrow>
      <div
        style={{
          color: '#242020',
          display: 'inline-flex',
          transition: 'transform 0.2s ease-in-out',
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.2)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        {React.cloneElement(config.icon, { sx: { fontSize: 20 } })}
      </div>
    </Tooltip>
  );
};

LeadSourceChip.propTypes = {
  source: PropTypes.string.isRequired,
};

export default LeadSourceChip;